module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$is('vehicle-id')) ? _c('div', {
    staticClass: "field-vehicle-id"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("V" + _vm._s(_vm.item.id))])]) : (_vm.$is('vehicle-image')) ? _c('div', {
    staticClass: "field-vehicle-image"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.picture_external
    }
  })])]) : (_vm.$is('vehicle-brand-and-lot')) ? _c('div', {
    staticClass: "field-vehicle-brand-and-lot"
  }, [(_vm.item.archived_at) ? _c('div', {
    staticClass: "field-value",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Archived")]) : _vm._e(), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.parking_lot.name))])]) : (_vm.$is('vehicle-lot')) ? _c('div', {
    staticClass: "field-vehicle-lot"
  }, [(_vm.item.parking_lot.name) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v("PL " + _vm._s(_vm.item.parking_lot.name))]) : _vm._e(), (_vm.item.vehicle_slot_address) ? _c('div', {
    staticClass: "field-value",
    staticStyle: {
      "max-width": "fit-content"
    }
  }, [_vm._v("VS" + _vm._s(_vm.item.slot_id) + " " + _vm._s(_vm.item.vehicle_slot_address))]) : _vm._e(), (_vm.item.federation !== null) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Federation: " + _vm._s(_vm.item.federation.name))]) : _vm._e()]) : (_vm.$is('vehicle-brand')) ? _c('div', {
    staticClass: "field-vehicle-brand"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))])]) : (_vm.$is('vehicle-lot-address')) ? _c('div', {
    staticClass: "field-vehicle-lot"
  }, [(_vm.item.vehicle_slot_address) ? _c('div', {
    staticClass: "field-value mb-1"
  }, [_vm._v("VS" + _vm._s(_vm.item.slot_id) + " " + _vm._s(_vm.item.vehicle_slot_address))]) : _vm._e(), (_vm.item.federation !== null) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Federation: " + _vm._s(_vm.item.federation.name))]) : _vm._e()]) : (_vm.$is('vehicle-brand')) ? _c('div', {
    staticClass: "field-vehicle-brand"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))])]) : (_vm.$is('vehicle-plate')) ? _c('div', {
    staticClass: "field-vehicle-plate"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_c('router-link', {
    staticClass: "hollow button secondary small",
    attrs: {
      "to": {
        name: 'vehicle',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.item.plate))])], 1)]) : (_vm.$is('vehicle-fuel-type')) ? _c('div', {
    staticClass: "field-vehicle-fuel-type"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Fuel Type")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.fuel_type))])]) : (_vm.$is('vehicle-category')) ? _c('div', {
    staticClass: "field-vehicle-category"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Category")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.category.name))])]) : (_vm.$is('vehicle-lot')) ? _c('div', {
    staticClass: "field-vehicle-lot"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Assigned lot")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.slot_name))])]) : (_vm.$is('vehicle-status')) ? _c('div', {
    staticClass: "field-vehicle-status"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Status  "), (_vm.item.slot_id !== null) ? _c('span', {
    staticClass: "float-right fa fa-circle",
    class: _vm.pointStatusColor
  }) : _vm._e()]), _c('vehicle-status', {
    attrs: {
      "item": _vm.item
    }
  })], 1) : (_vm.$is('vehicle-additional-status')) ? _c('div', {
    staticClass: "field-vehicle-additional-status"
  }, [_c('vehicle-additional-status', {
    attrs: {
      "item": _vm.item
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ef5ef3f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/entity-fields/VehicleFields.vue
// module id = 2253
// module chunks = 1